<template>
  <v-card class="confirmationCard">
    <v-card-title>
      {{
        biz_staff_responder.name && biz_staff_responder.name.trim()
          ? `${$t("responder_2")}：${biz_staff_responder.name}`
          : ""
      }}
    </v-card-title>
    <v-row class="pb-4 overflow-y: auto;" style="text-align: center">
      <!-- allow anyone to add any other variable amount of buttons, as needed, in reaction to PO wanting us to add extra stuff in ONLY one instance... -->
      <slot></slot>

      <v-col style="padding-bottom: 0">
        <v-btn
          class="inquiryBtn"
          color="#E95532"
          data-ktznta="181"
          depressed
          style="color: white"
          @click="$emit('completeBySwitchResponder', 'in_chat')"
        >
          {{ $t("complete_conversation") }}
        </v-btn>
      </v-col>

      <v-col style="padding-bottom: 0">
        <v-btn
          class="inquiryBtn"
          color="#FEF5F3"
          depressed
          style="color: #e95532"
          @click="$emit('completeBySwitchResponder', 'outside_chat')"
        >
          {{ $t("complete_outside_chat") }}
        </v-btn>
      </v-col>

      <v-col v-if="canReject" style="padding-bottom: 0">
        <v-btn class="inquiryBtn" color="#fc461c" outlined @click="$emit('refuseInquiry')">
          {{ $t("reject_inquiry") }}
        </v-btn>
      </v-col>

      <v-col>
        <v-btn class="inquiryBtn" color="#fc461c" text @click="$emit('handleCancel')">
          {{ $t("cancel") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import store from "@/store";
import { createComponent, onMounted, value, Wrapper } from "vue-function-api";
import { getBizResponder } from "@/modules/staff/services/responderApi";
import { QcBizResponder } from "@/modules/staff/objects/QcBizResponder";
import { ErrorService } from "@/framework/errors/ErrorService";

export default createComponent({
  setup(props, context) {
    const errorService = new ErrorService();
    const biz_staff_responder: Wrapper<QcBizResponder> = value(Object.assign({}));
    const staffMyself = store.getters.staff.myself;
    const canReject = staffMyself && staffMyself.tenant ? staffMyself.tenant.inquiry_reject_enabled : false;

    onMounted(async () => {
      console.log("Staff Header - mounted()");
      const res = await getBizResponder();
      if (res.isErr()) {
        return await errorService.handleError(res.error);
      }
      biz_staff_responder.value = res.value;
    });

    return {
      props,
      canReject,
      biz_staff_responder,
    };
  },
});
</script>

<style lang="scss" scoped>
.confirmationCard {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  max-height: 700px;
}

.inquiryBtn {
  width: 250px;
  height: 46px !important;
  font-weight: bold;
}
</style>
